import React, { useEffect, useState } from "react";
import LoginDefault from "./loginPages/LoginDefault";
import { useNavigate } from "react-router-dom";
import ROUTES_NAME from "../../constants/RoutesName";
import BranchAndCenterForm from "./branchAndCenterForm/BranchAndCenterForm";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Loader from '../../components/Loader'

function Login({ type, handleLogin }) {
  const navigate = useNavigate();
  const [popupBlocked, setPopupBlocked] = useState(false);

  useEffect(() => {
    const examToken = sessionStorage.getItem("examToken");
    const userName = sessionStorage.getItem("userName");

    function checkPopupEnabled() {
      const popup = window.open(
        "",
        "",
        "width=1,height=1,left=-1000,top=-1000"
      );

      if (!popup || popup.closed || typeof popup.closed === "undefined") {
        setPopupBlocked(true);
        return false;
      } else {
        popup.close();
        return true;
      }
    }

    const candidateLoggedinToInstructionsPage = sessionStorage.getItem(
      "candidateLoggedinToInstructionsPage"
    );

    if (examToken && userName && candidateLoggedinToInstructionsPage) {
      navigate(ROUTES_NAME.INSTRUCTION);
    }

    checkPopupEnabled();
  }, [navigate]);

  const [selectBranch, setSelectBranch] = useState(false);

  const componentMap = {
    iit: <LoginDefault handleLogin={handleLogin} />,
    default: <LoginDefault handleLogin={handleLogin} />,
  };

  const urlParams = new URLSearchParams(window.location.search);
  const key = urlParams.get("transferKey");

  return (
    <>
      {/* {sessionStorage.getItem("isBranchSelected") !== null || selectBranch ? (
        componentMap[type] || <LoginDefault handleLogin={handleLogin} />
      ) : (
        <BranchAndCenterForm setSelectBranch={setSelectBranch} />
      )} */}
      {!key && !sessionStorage.getItem('loginByClient')  ? <LoginDefault handleLogin={handleLogin} /> : <Loader/>}

      <Dialog
        open={popupBlocked}
        disableEscapeKeyDown
        aria-labelledby="popup-blocked-dialog-title"
        PaperProps={{
          sx: {
            borderRadius: 3,
            padding: 2,
            width: "600px",
            textAlign: "center",
          },
        }}
      >
        <DialogTitle
          id="popup-blocked-dialog-title"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            pb: 0,
          }}
        >
          <WarningAmberIcon sx={{ color: "error.main", fontSize: 40 }} />
          <Typography variant="h5" color="error.main" fontWeight={700}>
            Popup Blocked
          </Typography>
        </DialogTitle>

        <DialogContent dividers>
          <Typography
            variant="body1"
            sx={{
              mb: 2,
              fontSize: "18px",
              fontWeight: 500,
              color: "#333",
              lineHeight: 1.6,
            }}
          >
            Your browser is blocking popups. Please follow the steps below to
            enable popups for this site before continuing.
          </Typography>

          <Typography
            variant="body1"
            // color="text.secondary"
            sx={{
              textAlign: "left",
              fontSize: "17px",
              lineHeight: 1.8,
            }}
          >
            <strong>Steps to enable popups:</strong>
            <ul
              style={{ textAlign: "left", marginTop: "12px", fontSize: "16px" }}
            >
              <li style={{ marginTop: "10px" }}>
                <b> Chrome:</b> Go to{" "}
                <b>
                  Settings → Privacy and security → Site settings → Pop-ups and
                  redirects
                </b>{" "}
                → Allow pop-ups for this site.
              </li>
              <li style={{ marginTop: "10px" }}>
                <b> Edge:</b> Go to{" "}
                <b>
                  Settings → Cookies and site permissions → Pop-ups and
                  redirects
                </b>{" "}
                → Allow pop-ups for this site.
              </li>
              <li style={{ marginTop: "10px" }}>
                <b> Firefox:</b> Go to{" "}
                <b>Settings → Privacy & Security → Permissions</b> → Uncheck
                “Block pop-up windows” or add an exception for this site.
              </li>
              <li style={{ marginTop: "10px" }}>
                <b> Other browsers:</b> Please allow pop-ups manually from your
                browser’s settings or site permissions.
              </li>
            </ul>
          </Typography>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default Login;
